import React from 'react';
import { useTranslation } from 'react-i18next';
import { Section } from '@wix/da-shared-react/pkg/a11y/headings/tagWrappers';
import VisuallyHidden from '@wix/da-shared-react/pkg/a11y/VisuallyHidden';
import Heading from '@wix/da-shared-react/pkg/a11y/headings/Heading';
import FacetPage from '../FacetPage';
import PageContainer from '../PageContainer';
import BrowsePageHeading from '../BrowsePageHeading';
import ContentLoader from '../ContentLoader';
import BrowseThumbLayout from '../BrowseThumbLayout';

export interface Props {}

const BrowsePage: React.FC<Props> = props => {
  const { t } = useTranslation();
  return (
    <>
      {/*
        We're putting this h1 out here because we need it to be before any sections in the page.

        This makes sure that this heading is associated with the body.
      */}
      <BrowsePageHeading />
      <PageContainer>
        <Section>
          <VisuallyHidden>
            <Heading>{t('facetPage.contentHeading')}</Heading>
          </VisuallyHidden>
          <FacetPage>
            <ContentLoader>
              <BrowseThumbLayout />
            </ContentLoader>
          </FacetPage>
        </Section>
      </PageContainer>
    </>
  );
};
BrowsePage.displayName = 'BrowsePage';

export default BrowsePage;
